import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageLayout from "@/components/PageLayout";
import ProjectForm, { ProjectFormValues } from "@/components/ProjectForm";
import { useCreateProject } from "@/hooks/useProjects";

const CreateProject = () => {
  const navigate = useNavigate();
  const createProject = useCreateProject();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ProjectFormValues) => {
    setIsSubmitting(true);
    try {
      const newProject = await createProject.mutateAsync({
        name: values.name,
        code: values.code,
        kantataProjectId: values.kantataProjectId,
        clientIds: values.clientIds,
        startDate: new Date().toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }),
        therapyArea: values.therapyArea,
        condition: values.condition,
        objective: values.objective,
        projectType: values.projectType,
        model: values.model,
        dataRetentionDefault: values.dataRetentionDefault,
        memberIds: values.memberIds,
      });

      navigate(`/projects/${newProject.id}`);
    } catch {
      setIsSubmitting(false);
    }
  };

  return (
    <PageLayout mainClassName="container-md px-6 py-8">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-brand-teal hover:underline mb-6">
        <ArrowLeft className="w-4 h-4" />
        Back to Projects
      </Link>

      <h1 className="text-2xl font-bold text-brand-navy mb-2">Initiate New Project</h1>
      <p className="text-muted-foreground mb-8">Enter basic project information to get started. You can amend these fields later throughout the project.</p>

      <ProjectForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        submitLabel="Continue to Project Setup"
      />
    </PageLayout>
  );
};

export default CreateProject;
